import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import './index.less';

import CommonHeader from '../../organisms/CommonHeader';

import {
  isCompanyDetailRoute,
  isCustomerOrdersRoute,
  isGalleryRoute,
  isSingleRoute,
  isResellerReviewRoute,
  isImageViewRoute,
  isReviewRoute,
  isResellerViewRoute,
  NAME as ROUTE_NAME
} from '../../lib/Route';
import { isSizeGuidModalVisible } from '../../lib/Utils';
import EventBus from '../../lib/EventBus';
import { shouldShowMandatoryLogin } from '../../lib/Experiments';

export const NavBar = (props) => {
  const [display, setDisplay] = useState(null);
  const [mandatoryLoginDone, setMandatoryLoginDone] = useState(false);

  const { amalgamFetched, currentRoute, goBack, showBackForSingleCatalogue } = props;
  const singleOrGalleryRoute = isSingleRoute(currentRoute) || isGalleryRoute(currentRoute);
  const resellerViewRoute = isResellerViewRoute(currentRoute);
  const reviewRoute = isReviewRoute(currentRoute);
  const customerOrdersRoute = isCustomerOrdersRoute(currentRoute);
  const resellerReviewRoute = isResellerReviewRoute(currentRoute);
  const companyDetailRoute = isCompanyDetailRoute(currentRoute);
  const imageRoute = isImageViewRoute(currentRoute);

  useEffect(() => {
    EventBus.addListener(EventBus.TYPE.MANDATORY_LOGIN_DONE, onMandatoryLoginDone);
    EventBus.addListener(EventBus.TYPE.SIZE_GUIDE_MODAL, onSizeGuideModalVisibilityChange);
    return () => {
      EventBus.removeListener(EventBus.TYPE.MANDATORY_LOGIN_DONE, onMandatoryLoginDone);
      EventBus.removeListener(EventBus.TYPE.SIZE_GUIDE_MODAL, onSizeGuideModalVisibilityChange);
    };
  }, []);

  const onMandatoryLoginDone = () => {
    setMandatoryLoginDone(true);
  };

  const onSizeGuideModalVisibilityChange = () => {
    const newDisplay = isSizeGuidModalVisible() ? 'none' : null; // for showing modal above this button;
    if (display !== newDisplay) {
      setDisplay(newDisplay);
    }
  };

  const getContainerStyle = () => ({
    display
  });

  const showMandatoryLogin = () => !mandatoryLoginDone && shouldShowMandatoryLogin();

  if (
    (!singleOrGalleryRoute &&
      !reviewRoute &&
      !customerOrdersRoute &&
      !resellerViewRoute &&
      !resellerReviewRoute) ||
    ((singleOrGalleryRoute || resellerViewRoute) && !amalgamFetched) ||
    companyDetailRoute ||
    imageRoute ||
    showMandatoryLogin()
  ) {
    return null;
  }

  return (
    <CommonHeader
      containerStyle={getContainerStyle()}
      showBanner={false}
      showSearch={
        [
          ROUTE_NAME.GALLERY,
          ROUTE_NAME.RESELLER_CATALOGUE_GALLERY,
          ROUTE_NAME.GLOBAL_REVIEW,
          ROUTE_NAME.CUSTOMER_ORDERS,
          ROUTE_NAME.CUSTOMER_ORDERS_DETAILS,
          ROUTE_NAME.RESELLER_GLOBAL_REVIEW
        ].indexOf(currentRoute) === -1
      }
      showExpandedHeader={false}
      showHeaderCollapsedBorder={isCustomerOrdersRoute(currentRoute)}
      showHeaderCollapsedShadow={[ROUTE_NAME.GLOBAL_REVIEW].indexOf(currentRoute) === -1}
      goBack={goBack}
      showBackForSingleCatalogue={showBackForSingleCatalogue}
    />
  );
};

export default NavBar;
